@if (!isNewEDPScoreboard) {
    <div class="event-name">
        <ms-favourite-event-toggle class="participant-favourite" [event]="event" />
        <span class="participant-name">{{ event.name }} </span>
    </div>
} @else {
    <div class="participant-info">
        @if (showCompetitionLogo) {
            <ms-competition-logo [sportId]="event.sport.id" [leagueId]="event.league.id" [imageProfile]="event.league.imageProfile" />
        } @else {
            <ms-participant-image
                class="participant-image"
                [participantImage]="event.league.imageProfile"
                [sportId]="event.sport.id"
                [showFallback]="isNewEDPScoreboard" />
        }
        <div class="participant-name">
            {{ event.name }}
            <span class="participant-country">{{ event.league.name }}</span>
        </div>
    </div>
}
<div class="event-time">
    @if (showDate) {
        <div class="date">
            {{ showDate }}
            @if (!isNewEDPScoreboard) {
                <span> • </span>
            }
            {{ event.startDate | date: 'shortTime' }}
        </div>
    }
</div>
